import React from "react";
import Switch from "react-switch";
import * as c from "./toggleButton.module.scss";

export default function ToggleButton({ name, checked, label, onChange }) {
  return (
    <div className={c.container}>
      <Switch
        checked={checked}
        onChange={onChange}
        id={name}
        onColor="#30c2a6"
        height={24}
        handleDiameter={20}
        width={44}
        uncheckedIcon={false}
        checkedIcon={false}
      />
      <label htmlFor={name} className={c.label}>
        {label}
      </label>
    </div>
  );
}
